import React from 'react';

import { ActivitySectionLayout } from 'modules/components/layer32';
import { PlanSetTable } from 'modules/components/layer25';


export type PlanSetsDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanSetsDetailSectionProps) => {

  return (
    <ActivitySectionLayout.FC >
      <PlanSetTable.FC />
    </ActivitySectionLayout.FC>
  );
};
